<template>
  <v-card class="card-pad mx-auto" width="900px">
    <v-dialog v-model="alterDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Os dados informados não serão salvos, deseja continuar?') }}
          </div>

          <v-btn class="ma-1" color="grey" text @click="alterDialog = false">
            {{ $t('Não') }}
          </v-btn>

          <v-btn class="ma-1" color="#B14949" text @click="closeDialog">
            {{ $t('Sim') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="alertDialog" max-width="900">
      <ManageAlert
        title="Novo alerta"
        :alert="alert"
        :newAlert="true"
        @close="closeDialog"
        :key="dialogKey"
      />
    </v-dialog>

    <v-dialog v-model="closeLaborDialog" max-width="600px">
      <CloseTask :labor="currentLabor" @close="closeDialog" :key="dialogKey" />
    </v-dialog>

    <v-btn absolute top right depressed dark icon @click="close">
      <v-icon color="#bbb">mdi-close</v-icon>
    </v-btn>

    <div class="d-flex justify-center my-3">
      <h2>{{ $t(title) }}</h2>
    </div>

    <span class="main-subtitle ml-6">{{ $t(currentTitle) }}</span>

    <v-divider class="ma-6 my-2"></v-divider>

    <v-window v-model="step" touchless>
      <v-window-item :value="0">
        <v-form
          class="form"
          ref="firstForm"
          v-model="firstValid"
          lazy-validation
          :disabled="institutionInactive || departmentInactive"
        >
          <v-row class="ma-0" dense v-show="institutionInactive">
            <v-col class="py-0" cols="12">
              <InstitutionInactive />
            </v-col>
          </v-row>
          <v-row class="ma-0" dense v-show="departmentInactive">
            <v-col class="py-0" cols="12">
              <DepartmentInactive />
            </v-col>
          </v-row>
          <v-row class="ma-0 mx-6" dense>
            <v-col
              cols="12"
              class="text-end"
              v-if="currentLabor.eLaborStatus == 1"
            >
              <p style="font-size: 1.2rem; color: #b14949">
                {{ $t('Tarefa fechada em') }}
                {{ formatDateTime(currentLabor.closeDate) }}
              </p>
            </v-col>
            <v-col class="pb-0" cols="12" sm="6" md="6" lg="6">
              <label class="label">{{ $t('Instituição') }}</label>
              <v-autocomplete
                hide-details="auto"
                v-model="institutionId"
                :items="institutions"
                item-text="name"
                item-value="id"
                :loading="institutionLoading"
                :rules="[(v) => !!v || $t('Instituição é requerida')]"
                disabled
                outlined
                class="primary-input"
                append-icon=""
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-autocomplete>
            </v-col>

            <v-col class="pb-0" cols="12" sm="6" md="6" lg="6">
              <label class="label">{{ $t('Unidade') }}</label>
              <v-autocomplete
                hide-details="auto"
                :rules="[(v) => !!v || $t('Unidade requerida')]"
                v-model="unidadeId"
                :items="unidades"
                item-text="name"
                item-value="id"
                :loading="unidadeLoading"
                :disabled="!institutionId"
                :placeholder="
                  !institutionId ? $t('Selecione uma instituição') : ''
                "
                outlined
                class="primary-input"
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-autocomplete>
            </v-col>

            <v-col class="pb-0" cols="12" sm="6" md="6" lg="3">
              <label class="label">{{ $t('Nº tarefa') }}</label>
              <v-text-field
                hide-details="auto"
                :placeholder="$t('Gerado ao salvar')"
                disabled
                v-model="currentLabor.number"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>

            <v-col class="pb-0" cols="12" sm="6" md="6" lg="5">
              <label class="label">{{ $t('Responsável') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentUser.name"
                outlined
                class="primary-input"
                disabled
              >
              </v-text-field>
            </v-col>

            <v-col class="pb-0" cols="12" sm="6" md="6" lg="4">
              <label class="label">{{ $t('Solicitante') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentLabor.requester"
                :rules="[
                  (v) => !!v || $t('Solicitante requerido'),
                  (v) =>
                    (v && v.length <= 128) ||
                    $t('Solicitante deve ter no máximo 128 caracteres'),
                ]"
                outlined
                class="primary-input"
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-text-field>
            </v-col>

            <v-col class="pb-0" cols="12" :sm="isEditing ? '8' : '4'">
              <label class="label">{{ $t('Tipo tarefa') }}</label>
              <v-autocomplete
                hide-details="auto"
                v-model="currentLabor.laborType"
                :items="laborTypes"
                :rules="[(v) => v != -1 || $t('Tipo de tarefa requerida')]"
                outlined
                class="primary-input"
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-autocomplete>
            </v-col>

            <v-col class="pb-0" cols="12" sm="6" md="6" lg="4">
              <label class="label">{{ $t('Data e hora tarefa') }}</label>
              <div class="d-flex">
                <date-picker
                  ref="datepicker"
                  style="width: 100%"
                  v-model="laborDateTime"
                  mode="dateTime"
                  is24hr
                  :popover="{ visibility: 'click', positionFixed: 'true' }"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <v-text-field
                      prepend-inner-icon="mdi-calendar"
                      outlined
                      hide-details=""
                      class="primary-input"
                      :value="inputValue"
                      v-on="inputEvents"
                      v-mask="['##/##/#### ##:##']"
                      @focus="setLaborNowDate"
                      :disabled="institutionInactive || departmentInactive"
                    />
                    <span class="date-span-error" v-if="laborDateTimeError">
                      {{ $t('Data da tarefa requerida') }}
                    </span>
                  </template>
                </date-picker>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mt-3 ml-1"
                      :disabled="!laborDateTime"
                      x-small
                      depressed
                      color="#DC143C"
                      v-bind="attrs"
                      v-on="on"
                      @click="createAlert"
                    >
                      <v-icon small>mdi-bell-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('Criar alerta') }}</span>
                </v-tooltip>
              </div>
            </v-col>

            <v-col
              class="pb-0"
              cols="12"
              sm="6"
              md="6"
              lg="4"
              v-if="isEditing && closeDate"
            >
              <label class="label">{{ $t('Data e hora fechamento') }}</label>
              <div class="d-flex">
                <date-picker
                  ref="datepicker"
                  style="width: 100%"
                  v-model="closeDate"
                  mode="dateTime"
                  is24hr
                  :popover="{ visibility: 'click', positionFixed: 'true' }"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <v-text-field
                      prepend-inner-icon="mdi-calendar"
                      outlined
                      hide-details=""
                      class="primary-input"
                      :value="inputValue"
                      v-on="inputEvents"
                      v-mask="['##/##/#### ##:##']"
                      @focus="setCloseDate"
                      :disabled="institutionInactive || departmentInactive"
                    />
                  </template>
                </date-picker>
              </div>
            </v-col>

            <v-col v-if="isEditing">
              <label class="label">{{ $t('Horas despendidas') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="hoursSpent"
                :rules="[
                  (v) => !!v || $t('Horas despendidas requeirda'),
                  (v) => (v && v.length == 5) || $t('Tempo inválido'),
                ]"
                v-mask="['##:##']"
                outlined
                class="primary-input"
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-text-field>
            </v-col>

            <v-col class="pb-0" cols="12" sm="6" md="6" lg="4">
              <label class="label">{{ $t('Setor') }}</label>
              <v-autocomplete
                :disabled="!unidadeId"
                hide-details="auto"
                v-if="!departmentInactive"
                v-model="departmentId"
                :items="departments"
                item-text="name"
                item-value="id"
                :loading="departmentLoading"
                :rules="[(v) => !!v || $t('Setor requerido')]"
                outlined
                class="primary-input"
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-autocomplete>
              <v-text-field
                hide-details="auto"
                v-else
                v-model="currentLabor.department.name"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>

            <v-col class="pb-0" cols="12">
              <label class="label">{{ $t('Tarefa') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentLabor.name"
                :rules="[
                  (v) => !!v || $t('Tarefa requerida'),
                  (v) =>
                    (v && v.length <= 128) ||
                    $t('Tarefa deve ter no máximo 128 caracteres'),
                ]"
                outlined
                class="primary-input"
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
              lg="6"
              class="d-flex align-center py-0"
            >
              <span class="label"> {{ $t('Exibir no calendário') }} </span>
              <v-switch
                inset
                v-model="currentLabor.showCalendar"
                :label="`${currentLabor.showCalendar ? $t('Sim') : $t('Não')}`"
                color="#BBCF20"
                class="mx-4 label"
              >
              </v-switch>
            </v-col>
            <v-col class="py-0" cols="12" v-if="isEditing">
              <v-btn
                v-show="currentLabor.eLaborStatus != 1"
                @click="closeLabor"
                class="hidden-md-and-up"
                color="#bbcf20"
                >{{ $t('Fechar tarefa') }}</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </v-window-item>

      <v-window-item :value="1">
        <div class="fill-height text-center pa-8">
          <v-icon size="60" color="success">
            mdi-checkbox-marked-circle
          </v-icon>

          <span style="display: block; margin-top: 10px; font-size: 1.2rem">
            {{
              isEditing
                ? $t('Tarefa atualizada com sucesso!')
                : $t('Tarefa cadastrada com sucesso!')
            }}
          </span>
        </div>
      </v-window-item>
    </v-window>

    <v-divider class="mb-6 mt-2 mx-8"></v-divider>

    <div class="d-flex mx-6">
      <v-btn
        depressed
        @click="close"
        v-if="step === 0"
        class="quaternary-button"
        color="#B14949"
      >
        {{ $t('Cancelar') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        depressed
        v-show="currentLabor.eLaborStatus != 1"
        @click="closeLabor"
        class="secondary-button hidden-sm-and-down mr-3"
        v-if="isEditing && step != 1"
        :disabled="institutionInactive || departmentInactive"
      >
        {{ $t('Fechar tarefa') }}
      </v-btn>
      <v-btn
        depressed
        class="primary-button mr-0"
        @click="next"
        :loading="loading"
        :disabled="institutionInactive || departmentInactive"
      >
        {{ $t(buttonText) }}
      </v-btn>
    </div>
  </v-card>
</template>

<style scoped>
.v-application .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}

.date-input {
  background: var(--primary-input-background) !important;
  font-family: var(--primary-input-font) !important;
  font-size: var(--primary-input-font-size) !important;
  font-weight: var(--primary-input-font-weigth) !important;
  line-height: var(--primary-input-line-height) !important;
  letter-spacing: var(--primary-input-letter-spacing) !important;
  border-radius: var(--primary-input-border-radius) !important;
  height: 45px;
  width: 100%;
  border: 1px solid #707070 !important;
  padding-left: 10px !important;
}

.date-input-error {
  background: var(--primary-input-background) !important;
  font-family: var(--primary-input-font) !important;
  font-size: var(--primary-input-font-size) !important;
  font-weight: var(--primary-input-font-weigth) !important;
  line-height: var(--primary-input-line-height) !important;
  letter-spacing: var(--primary-input-letter-spacing) !important;
  border-radius: var(--primary-input-border-radius) !important;
  height: 45px;
  width: 100%;
  border: 2px solid #ff5252 !important;
  padding-top: 0 !important;
}
@media (max-width: 600px) {
  .v-card__text {
    padding: 0;
  }
}
</style>

<script>
import ApiService from '../../../../services/ApiService'
import Utils from '../../../../Utils/FormatDate'
import CloseTask from './CloseTask.vue'
import ManageAlert from '../../Alert/components/manageAlert/ManageAlert.vue'
import InstitutionInactive from '../../Institutions/components/institutionInactive/institutionInactive.vue'
import DepartmentInactive from '../../Department/deparmentInactive/departmentInactive.vue'

export default {
  props: {
    title: String,
    labor: Object,
  },

  components: {
    CloseTask,
    ManageAlert,
    InstitutionInactive,
    DepartmentInactive,
  },

  created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = this.institution.id
    this.institutionInactive = this.institution.status == 1
    this.getInstitutions()
    this.getUsers()
    this.getUnidades()

    if (this.institution.userType > 1) {
      this.unidadeId = this.userLogged.unidadeId
    }

    this.currentUser = this.userLogged
    if (this.labor) {
      this.currentLabor = this.labor
      this.currentLabor.laborType = this.laborTypes[this.labor.eLaborType]
      this.unidadeId = this.labor.unidadeId
      this.departmentId = this.labor.departmentId
      this.currentUser = this.labor.user
      this.laborDateTime = this.labor.laborDate
      this.hoursSpent = this.labor.hoursSpent
      this.closeDate = this.labor.closeDate
      this.departmentInactive = this.labor.department.status == 1
      this.isEditing = true
    }
  },

  data: () => ({
    hoursSpent: '',
    institution: {},
    closeDate: '',
    step: 0,
    selectedTab: 0,
    tab: null,
    errorMessage: '',
    loading: false,
    unidadeLoading: false,
    institutionLoading: false,
    departmentLoading: false,
    userLoading: false,
    firstValid: true,
    alterDialog: false,
    alertDialog: false,
    dialogKey: false,
    closeLaborDialog: false,
    changedData: false,
    isEditing: false,
    error: false,
    laborDateTimeError: false,
    institutionInactive: false,
    departmentInactive: false,
    laborDateTime: null,
    unidadeId: 0,
    unidades: [],
    departmentId: 0,
    departments: [],
    institutionId: null,
    institutions: [],
    userLogged: {},
    currentUser: {},
    users: [],
    alert: {},
    laborTypes: [
      'Validação de equipamentos',
      'Treinamento',
      'Serviço administrativo',
      'Rotina de inspeção',
      'Serviço Operacional',
    ],
    laborsStatus: ['Aberta', 'Fechada'],
    currentLabor: {
      id: 0,
      name: '',
      requester: '',
      number: '',
      laborType: -1,
      laborStatus: 0,
      laborDate: null,
      showCalendar: false,
    },

    userRules: [(v) => !!v || 'Responsável requerido'],

    apiService: new ApiService(),
  }),

  computed: {
    currentTitle() {
      switch (this.step) {
        case 0:
          return 'Dados gerais'
        default:
          return this.isEditing ? 'Atualização efetuada' : 'Cadastro efetuado'
      }
    },

    buttonText() {
      switch (this.step) {
        case 0:
          return this.isEditing ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$emit('close')
      }
    },

    closeDialog() {
      if (this.closeLaborDialog) {
        this.closeLaborDialog = false
      } else if (this.alertDialog) {
        this.alertDialog = false
      } else {
        this.changedData = false
        this.close()
      }
    },

    createAlert() {
      this.alert = {
        description: `Tarefa - ${this.currentLabor.laborType}`,
        eventDateTime: this.laborDateTime,
        alertModule: 3,
        laborId: this.currentLabor.id,
        userId: this.currentUser.id,
      }

      this.dialogKey = !this.dialogKey
      this.alertDialog = true
    },

    closeLabor() {
      this.dialogKey = !this.dialogKey
      this.closeLaborDialog = true
      this.changedData = false
      this.close()
    },

    converterStatusToInt(status) {
      if (status) {
        this.currentLabor.showCalendar = 0
      } else {
        this.currentLabor.showCalendar = 1
      }
    },

    setLaborNowDate() {
      this.laborDateTime = !this.laborDateTime ? new Date() : this.laborDateTime
    },

    setCloseDate() {
      this.closeDate = !this.closeDate ? new Date() : this.closeDate
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate() && this.laborDateTime) {
          this.submit()
        } else {
          this.laborDateTimeError = true
        }
      } else {
        this.closeDialog()
      }
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content
        this.institutionLoading = false
      })
    },

    async getUnidades() {
      if (this.institutionId == null) return

      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getDepartments() {
      this.departmentLoading = true

      await this.apiService
        .get(`department/list/unidade/${this.unidadeId}`)
        .then((response) => {
          this.departments = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.departmentLoading = false
    },

    async getUsers() {
      this.userLoading = true

      await this.apiService
        .get(`user/list/${this.institutionId}`)
        .then((response) => {
          this.users = response.content
          this.userLoading = false
        })
    },

    async submit() {
      this.loading = true

      const labor = {
        Id: this.currentLabor.id,
        Name: this.currentLabor.name,
        eLaborType: this.laborTypes.indexOf(this.currentLabor.laborType),
        UserId: this.currentUser.id,
        Requester: this.currentLabor.requester,
        DepartmentId: this.departmentId,
        InstitutionId: this.institutionId,
        UnidadeId: this.unidadeId,
        closeDate: this.closeDate,
        hoursSpent: this.hoursSpent,
        eLaborStatus: this.isEditing
          ? this.laborsStatus.indexOf(this.currentLabor.laborStatus)
          : this.currentLabor.laborStatus,
        LaborDate: Utils.nowDatetimeFormat(this.laborDateTime),
        ShowCalendar: this.currentLabor.showCalendar,
      }

      let url = 'labor/add'

      if (this.isEditing) {
        url = 'labor/edit'
      }

      await this.apiService
        .post(url, labor)
        .then(() => {
          this.step++
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.loading = false
      this.changedData = false
    },

    parseDate(date) {
      if (!date) return null

      const dateTimeSplit = date.split(' ')

      const [day, month, year] = dateTimeSplit[0].split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${
        dateTimeSplit[1]
      }:00`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('T')[0].split('-')
      return `${day}/${month}/${year}`
    },

    formatDateTime(date) {
      return Utils.dateTime(date)
    },
  },

  watch: {
    unidadeId() {
      this.getDepartments()
    },

    currentLabor: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },

    laborDateTime: {
      deep: true,
      handler() {
        this.changedData = true
        this.laborDateTimeError = false
      },
    },
  },
}
</script>
